var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "page-content d-flex flex-column" },
    [
      _c("Titlebar", { attrs: { incrustation: "fa-pie-chart" } }, [
        _c("h1", [_vm._v(_vm._s(_vm.$t("home.title")))]),
      ]),
      _vm._v(" "),
      _vm.displayWarning
        ? _c(
            "div",
            {
              staticClass:
                "alert alert-warning m-3 flex-1 d-flex flex-row justify-content-between align-items-center",
            },
            [
              _c("span", {
                domProps: { innerHTML: _vm._s(_vm.$t("general_warning")) },
              }),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "close",
                  attrs: {
                    type: "button",
                    "data-dismiss": "alert",
                    "aria-label": _vm.$t("global.close"),
                  },
                  on: { click: _vm.dismissWarning },
                },
                [
                  _c("span", { attrs: { "aria-hidden": "true" } }, [
                    _vm._v("×"),
                  ]),
                ]
              ),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "flex-1",
          staticStyle: { margin: "0 -16px", width: "calc(100% + 16px + 16px)" },
          attrs: { id: "home-container" },
        },
        [
          _c(
            "grid-layout",
            {
              attrs: {
                layout: _vm.layout,
                "col-num": 3,
                maxRows: 1,
                "row-height": _vm.rowHeight,
                "is-draggable": false,
                "is-resizable": false,
                "vertical-compact": true,
                margin: [16, 0],
                "use-css-transforms": false,
              },
            },
            _vm._l(_vm.layout, function (item, index) {
              return _c(
                "grid-item",
                {
                  key: item.i,
                  class: item.fullscreenClass,
                  attrs: {
                    x: index,
                    y: item.y,
                    w: 1,
                    h: 1,
                    i: item.i,
                    dragIgnoreFrom: ".grid-item-inner,.zmdi",
                  },
                },
                [
                  _c(
                    "UiCard",
                    {
                      staticStyle: {
                        padding: "0!important",
                        overflow: "hidden",
                        height: "100%",
                      },
                    },
                    [
                      _c(
                        "h3",
                        {
                          staticClass:
                            "vue-draggable-handle bg-gray-200 text-gray-700",
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(item.widgetOptions.title) +
                              "\n            "
                          ),
                          _c("i", {
                            staticClass:
                              "fa fa-info-circle text-dark warning-beepiz-remote-monitoring show",
                            staticStyle: {
                              right: "30px",
                              "font-size": "1.5em",
                            },
                          }),
                          _vm._v(" "),
                          item.widgetOptions.id == 22
                            ? _c(
                                "div",
                                {
                                  staticClass: "tooltip top",
                                  staticStyle: {
                                    width: "250px",
                                    right: "40px",
                                    top: "50px",
                                  },
                                },
                                [
                                  _c("h5", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "home.widgets.list.sessionInfoTitle"
                                        )
                                      )
                                    ),
                                  ]),
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        _vm.$t(
                                          "home.widgets.list.sessionInfoBody"
                                        )
                                      ) +
                                      "\n            "
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          item.widgetOptions.id == 23
                            ? _c(
                                "div",
                                {
                                  staticClass: "tooltip top",
                                  staticStyle: {
                                    width: "250px",
                                    right: "40px",
                                    top: "50px",
                                  },
                                },
                                [
                                  _c("h5", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("home.widgets.list.mapInfoTitle")
                                      )
                                    ),
                                  ]),
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        _vm.$t("home.widgets.list.mapInfoBody")
                                      ) +
                                      "\n            "
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          item.widgetOptions.id == 24
                            ? _c(
                                "div",
                                {
                                  staticClass: "tooltip top",
                                  staticStyle: {
                                    width: "250px",
                                    right: "40px",
                                    top: "50px",
                                  },
                                },
                                [
                                  _c("h5", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "home.widgets.list.eventInfoTitle"
                                        )
                                      )
                                    ),
                                  ]),
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        _vm.$t(
                                          "home.widgets.list.eventInfoBody"
                                        )
                                      ) +
                                      "\n            "
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c("i", {
                            staticClass: "zmdi",
                            class: item.fullscreenClass
                              ? "zmdi-fullscreen-exit"
                              : "zmdi-fullscreen",
                            on: {
                              click: function ($event) {
                                $event.stopPropagation()
                                return _vm.handleFullscreen(item)
                              },
                            },
                          }),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "grid-item-inner text-sm" },
                        [
                          _c(item.widget, {
                            ref: _vm.getWidgetId(item),
                            refInFor: true,
                            tag: "component",
                            attrs: {
                              options: item.widgetOptions,
                              source: item.source,
                              resize: _vm.resizeMap,
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  ),
                ],
                1
              )
            }),
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }